<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <click-show-content :expand-by-default="hasAttachedFiles">
    <template #clickable-content>
      <div class="inline-block">
        <span class="label label-sm bgm-lightgray f-13 f-500 c-indigo">
          {{ $t('Add an attachment') }}
        </span>
      </div>
      &nbsp;
      <small class="c-gray">
        {{ $t('Upload anything that’ll bring your job to life.') }}
      </small>
    </template>
    <template #expandable-content>
      <div>
        <h4>{{ $t('Attached files') }}</h4>
      </div>

      <FormFilesList :files="selectedFiles" @toggle-file-deletion="toggleFileDeletion" />

      <br />

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <PickerFileFilebank
        v-slot="{ openFilePicker }"
        :no-top-margin="true"
        :default-tags="[$t('Jobs')]"
        :exclude-ids="selectedFiles.map((f) => f.localId)"
        @files-selected="addFiles"
      >
        <span class="btn btn-primary pointer" @click="openFilePicker">
          + {{ $t('Find and add') }}
        </span>
      </PickerFileFilebank>
    </template>
  </click-show-content>
</template>

<script>
import FormFilesList from '@/components/jobs/FormFilesList.vue'

export default {
  components: { FormFilesList },
  props: {
    files: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedFiles: this.initialSelectedFiles(),
    }
  },
  computed: {
    hasAttachedFiles() {
      return this.files.length > 0
    },
    selectedFileIds() {
      return this.selectedFiles.map((f) => f.localId)
    },
  },
  methods: {
    addFiles(fileArray) {
      const incomingFiles = fileArray
        .filter((f) => !this.selectedFileIds.includes(f.localId))
        .map((f) => ({
          ...f,
          isReviewed: false,
          isRemoved: false,
          storage_name: f.storageName,
        }))
      this.selectedFiles.push(...incomingFiles)
    },
    initialSelectedFiles() {
      return this.files.length > 0
        ? this.files.map((f) => ({
            ...f,
            localId: f.id ?? f.localId,
            isRemoved: false,
          }))
        : []
    },
    toggleFileDeletion(k) {
      this.selectedFiles[k].isRemoved = !this.selectedFiles[k].isRemoved
    },
  },
}
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
}
</style>
